 <template>
  <div class="footer_frame clearfix" :style="{ background: back }">
    <div class="common_frame f14 clearfix">
      <ul>
        <li>首页</li>
        <!-- <li @click="router_push('LineCenter')" class='cursor'>直线模组</li> -->
        <li class="cursor" @click="router_push('Type')">选型计算</li>
      </ul>
      <ul>
        <li>直线模组</li>
        <!-- <li class="cursor">直线模组</li> -->
        <li
          class="cursor nowrap"
          v-for="(item, index) in goodtab"
          :key="index"
          @click="router_push('LineCenter', item.id)"
        >
          {{ item.name }}
        </li>
      </ul>
      <ul>
        <li>解决方案</li>
        <li
          class="nowrap cursor"
          v-for="(k, oindex) in tabData"
          :key="oindex"
          @click="router_push('SoluTion', k.id, k.name, 'solution')"
        >
          {{ k.name }}
        </li>
      </ul>
      <ul>
        <li>新闻中心</li>
        <li
          class="cursor"
          v-for="(n, indexs) in tablist"
          :key="indexs"
          @click="router_push('NewsCenter', n.id, n.name)"
        >
          {{ n.name }}
        </li>
      </ul>
      <ul>
        <li>关于我们</li>
        <li
          class="cursor"
          @click="router_push('AboutUs', about.name, about.id)"
          v-for="(about, kindex) in aboutData"
          :key="kindex"
        >
          {{ about.name }}
        </li>
      </ul>
      <ul>
        <li>联系方式</li>
        <li class="nowrap">电话：0512-88850560</li>
        <li class="nowrap">手机：18112604960</li>
        <a
          class="nowrap"
          href="mailto:sales@faster-motion.com"
          style="color:#343434;hover:color:red"
          >邮箱：sales@faster-motion.com</a
        >
        <!-- <li>点胶机平台</li> -->
      </ul>
      <div class="f16" style="text-align: center">
        <span>微信公众号</span>
        <img src="../../../static/img/common/h5code.jpg" alt="" />
      </div>
      <div class="f16" style="margin-right: 50px; text-align: center">
        <span>直驱在线app</span>
        <img src="../../../static/img/common/appcode.png" alt="" />
      </div>
      <div
        style="width: 100%; height: 30px; line-height: 30px"
        v-if="datalist.length != 0"
      >
        <span class="c33 f12">友情链接 : </span>
        <span
          v-for="(item, index) in datalist"
          class="f12 c33 cursor mr10"
          @click="check(item.url)"
          >{{ item.name }}</span
        >
      </div>
      <div class="footer_bottom f14">
        <p>Copyright © 飞创直线模组（苏州）有限公司 版权所有</p>
        <p
          style="height: 30px; margin-top: -50px; cursor: pointer"
          @click="to_beian"
        >
          苏ICP备17041631号-1
        </p>
        <!-- <p>
          飞创直线模组立足苏州，面向广东（广州、深圳、东莞、惠州）浙江（杭州、义乌、温州）江苏（南京、无锡、常州）上海、重庆、天津等省市提供直驱运动系统解决方案
        </p> -->
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">document.write(unescape("%3Cspan id='cnzz_stat_icon_1280361389'%3E%3C/span%3E%3Cscript src='https://s9.cnzz.com/z_stat.php%3Fid%3D1280361389%26show%3Dpic' type='text/javascript'%3E%3C/script%3E"));</script>
<script>
import { SendSMS, goodsList, columnlist } from "@/api/api";
export default {
  name: "footers",
  data() {
    return {
      datalist: [],
      back: "#F5F5F5",
      goodtab: "",
      cid: "",
      tabData: "",
      tablist: "",
      aboutData: "",
    };
  },
  methods: {
    //友情链接
    links() {
      let params = {
        what: "getYqLink",
      };
      SendSMS(params).then(
        (res) => {
          if (res.data.code == 1) {
            this.datalist = res.data.data;
          }
        },
        (err) => {}
      );
    },
    //跳转友情链接
    check(url) {
      window.open(url, "_blank");
    },
    //改变颜色
    back_color() {
      switch (this.$route.name) {
        case "LineCenter":
          this.back = "#ffffff";
          break;
        case "Type":
          this.back = "#ffffff";
          break;
        case "TypeThree":
          this.back = "#ffffff";
          break;
        case "TypeFour":
          this.back = "#ffffff";
          break;
        case "TypeFive":
          this.back = "#ffffff";
          break;
        case "TypeSix":
          this.back = "#ffffff";
          break;
        case "TypeSeven":
          this.back = "#ffffff";
          break;
        case "TypeEight":
          this.back = "#ffffff";
          break;
        case "TypeNine":
          this.back = "#ffffff";
          break;
        case "TypeTen":
          this.back = "#ffffff";
          break;
        case "TypeResult":
          this.back = "#ffffff";
          break;
        case "SoluTion":
          this.back = "#ffffff";
          break;
        case "ServiceSupport":
          this.back = "#ffffff";
          break;
        case "AboutUs":
          this.back = "#ffffff";
          break;
        case "Mine":
          this.back = "#ffffff";
          break;
        case "Order":
          this.back = "#ffffff";
          break;
        case "OrderDetail":
          this.back = "#ffffff";
          break;
        case "Plans":
          this.back = "#ffffff";
          break;
        case "Track":
          this.back = "#ffffff";
          break;
        case "Invoice":
          this.back = "#ffffff";
          break;
        case "AddressList":
          this.back = "#ffffff";
          break;
          ProductDetail;
        case "Complaint":
          this.back = "#ffffff";
          break;
        case "ProductDetail":
          this.back = "#ffffff";
          break;
        case "Plan":
          this.back = "#ffffff";
          break;
        case "News":
          this.back = "#ffffff";
          break;
        default:
          this.back = "#f5f5f5";
          break;
      }
    },
    //产品分类
    goodsLists() {
      let params = {
        action: "column",
      };
      goodsList(params).then(
        (res) => {
          this.goodtab = res.data.data;
          this.cid = res.data.data[0].id;
        },
        (err) => {
          console.log(err);
        }
      );
    },
    //头部栏目
    header_columm() {
      columnlist({ action: "column" }).then(
        (res) => {
          if (res.data.code == 1) {
            for (var i = 0; i < res.data.data.length; i++) {
              if (res.data.data[i].id == 58) {
                this.tabData = res.data.data[i].child[0];
              } else if (res.data.data[i].id == 41) {
                this.tablist = res.data.data[i].child[0];
              } else if (res.data.data[i].id == 59) {
                this.aboutData = res.data.data[i].child[0];
              }
            }
            // console.log(res.data.data)
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    router_push(name, id, names, type) {
      if (name == "SoluTion") {
        this.$router.push({
          name: name,
          query: { type: type, ids: id, name: names },
        });
      } else if (name == "NewsCenter") {
        this.$router.push({ name: name, query: { wid: id, name: names } });
      } else if (name == "AboutUs") {
        this.$router.push({ name: name, query: { name: id, pid: names } });
      } else if (name == "LineCenter") {
        this.$router.push({ name: name, query: { oid: id } });
      } else {
        this.$router.push({ name: name });
      }
      scrollTo(0, 0);
    },
    to_beian() {
      window.open("https://beian.miit.gov.cn/", "_blank");
    },
  },
  mounted() {
    this.links();
    this.goodsLists();
    this.back_color();
    this.header_columm();
  },
  watch: {
    $route() {
      this.back_color();
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../static/css/common.scss";
.footer_frame {
  width: 100%;
  height: auto;
  background: $white;
  border-top: 1px solid #dedede;
  box-sizing: border-box;
  padding-top: 53px;
}
  .common_frame {
    ul {
      width: 80px;
      color: #343434;
      margin-right: 60px;
      float: left;
      li {
        word-wrap: break-word;
        table-layout: fixed;
        word-break: break-all;
        margin-bottom: 10px;
      }
      li:hover {
        color: $blue;
      }
      li:nth-of-type(1) {
        font-size: 18px;
        font-weight: bold;
        padding-bottom: 35px;
        border-bottom: 1px solid $border;
      }
      li:nth-of-type(1):hover {
        color: #343434;
      }
    }
    div {
      float: right;
      width: 100px;
      height: auto;
      img {
        width: 80px;
        height: 80px;
        margin-top: 10px;
      }
    }
    .footer_bottom {
      color: #9a9a9a;
      text-align: center;
      height: 80px;
      line-height: 75px;
      border-top: 1px solid $border;
      clear: both;
      width: 100%;
      margin-top: 20px;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/Module1/footers.vue